export default __webpack_public_path__ + "static/media/crm.4b7cc260.svg";